import { useQuery } from "@tanstack/react-query";
import { apiClient, featuresKeys } from "../api";

export function useFeatures() {
  return useQuery({
    queryKey: featuresKeys.flags(),
    queryFn: () => apiClient.getFeatures(),
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: 1,
  });
}
